import styled from 'styled-components';
import { AppCard, AppCheckbox } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalConstructionDeconstructionNormalAspectsCard(
  props
) {
  const { filterApplicable, values, motive, setFieldValue } = props;

  if (filterApplicable && !values?.applicable) return null;

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <AppCheckbox
        title={
          values?.applicable
            ? ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="no.applicable"
                />
              )
            : ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="assign.as.applicable"
                />
              )
        }
        value={values?.applicable}
        className="d-inline-flex"
        onChange={(v) => setFieldValue('applicable', v)}
      />
      <AppCardContainer
        className="mb-2"
        bodyClassName="p-1"
        $applicable={values?.applicable}
      >
        <div className="info-block">
          <div className="line mb-2">
            <div>
              <Translator file="module-comsaEnvironmental" name="reason" />:
            </div>
            <div>
              <b>{motive}</b>
            </div>
          </div>
        </div>
      </AppCardContainer>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const AppCardContainer = styled(AppCard)`
  border: 2px solid ${(props) => (props.$applicable ? '#28a745' : '#fff')};
  .info-block {
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: ${colors.primaryLight};
    }
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
  }
`;
